import { useState, useEffect } from "react";
import { Platform as RNPlatform, Dimensions } from "react-native";
import { isTablet } from "react-native-device-info";

import { Orientation, Platform } from "consts";

const IS_WEB = RNPlatform.OS === "web";
const IS_IOS = RNPlatform.OS === "ios";
const IS_ANDROID = RNPlatform.OS === "android";

const IS_IOS_WEB =
  (IS_WEB && /iPad|iPhone|iPod/.test(navigator.userAgent)) ||
  (IS_WEB && navigator.userAgent.includes("Mac") && "ontouchend" in document);

const IS_ANDROID_WEB = IS_WEB && /(android)/i.test(navigator.userAgent);
const IS_MOBILE_WEB = IS_ANDROID_WEB || IS_IOS_WEB;
const IS_MOBILE = IS_MOBILE_WEB || (!IS_TABLET && (IS_IOS || IS_ANDROID));

const WEB_DEVICE_TYPE = !IS_WEB
  ? null
  : /(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(navigator.userAgent)
  ? "TABLET"
  : IS_MOBILE_WEB
  ? "MOBILE"
  : "DESKTOP";

const IS_TABLET = (IS_WEB && WEB_DEVICE_TYPE === "TABLET") || isTablet();

const IS_WEB_AUDIO_SUPPORTED = IS_WEB && !!window.MediaRecorder;

const _getOrientation = (width, height) =>
  width > height ? Orientation.LANDSCAPE : Orientation.PORTRAIT;

const getOrientation = () => {
  const { width, height } = Dimensions.get("window");
  return [_getOrientation(width, height), { width, height }];
};

const isLandscape = () => getOrientation()[0] === Orientation.LANDSCAPE;

const isPortrait = () => !isLandscape();

export const Device = {
  isPortrait,
  isLandscape,

  IS_WEB,
  IS_IOS,
  IS_TABLET,
  IS_MOBILE,
  IS_ANDROID,
  IS_IOS_WEB,
  IS_MOBILE_WEB,
  IS_ANDROID_WEB,
  WEB_DEVICE_TYPE,
  IS_WEB_AUDIO_SUPPORTED,
};

export const useOrientation = () => {
  const [orientation, setOrientation] = useState(getOrientation()[0]);

  useEffect(() => {
    const listener = dimensions => {
      const { width, height } = dimensions.window;
      const _orientation = _getOrientation(width, height);
      setOrientation(_orientation);
    };
    Dimensions.addEventListener("change", listener);
    return () => Dimensions.removeEventListener("change", listener);
  });

  return orientation;
};

export const pickStyle = (styles, theme) => {
  const [orientation, dimensions] = getOrientation();
  const platform = IS_TABLET
    ? Platform.TAB
    : IS_MOBILE_WEB || dimensions.width < 550
    ? Platform.AND
    : RNPlatform.OS;

  const mediaQuery = styles[platform]?.[orientation]
    ? platform
    : getPlatformWidth(dimensions);

  const style = styles[mediaQuery]?.[orientation];
  if (typeof style === "function") {
    return style(dimensions.width, dimensions.height, theme);
  } else {
    return style;
  }
};

const getPlatformWidth = dimensions => {
  return dimensions.width <= 1400 ? "max-width:1400" : "min-width:1400";
};

export const getViewHeight = height => {
  return () =>
    IS_WEB ? Dimensions.get("window").height * (height / 100) : height + "%";
};

export const getViewWidth = width => {
  return () =>
    IS_WEB ? Dimensions.get("window").width * (width / 100) : width + "%";
};
